import { useState } from "react";
import { IMAGES, MENU } from "../data";
import { Reveal } from "./Reveal";
import { EnquiryForm } from "./EnquiryForm";

const TABS = [
  { label: "Breakfast", testid: "menu-tab-breakfast" },
  { label: "Lunch", testid: "menu-tab-lunch" },
  { label: "Dinner", testid: "menu-tab-dinner" },
  { label: "Beverages", testid: "menu-tab-beverages" },
];

const FIELDS = [
  { name: "name", label: "Name", type: "text", required: true, placeholder: "Your full name", testid: "restaurant-form-name" },
  { name: "phone", label: "Phone", type: "tel", required: true, placeholder: "10-digit mobile number", testid: "restaurant-form-phone" },
  { name: "date", label: "Date", type: "date", required: true, testid: "restaurant-form-date" },
  { name: "time", label: "Time", type: "time", required: true, testid: "restaurant-form-time" },
  { name: "guests", label: "Number of Guests", type: "number", required: true, placeholder: "e.g. 4", testid: "restaurant-form-guests" },
  { name: "message", label: "Message", type: "textarea", placeholder: "Any special request?", testid: "restaurant-form-message" },
];

export const Restaurant = () => {
  const [tab, setTab] = useState("Breakfast");

  return (
    <section id="restaurant" data-testid="restaurant-section" className="bg-white py-16 sm:py-20 lg:py-28">
      <div className="section-wrap">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="eyebrow">Kasdol Restaurant</p>
          <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl lg:text-5xl">
            Good Food. Great Moments.
          </h2>
          <p className="mt-4 text-base text-ink/70 sm:text-lg">
            Enjoy delicious food in a warm and welcoming atmosphere at Kasdol Hotel Restaurant.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2">
          <Reveal>
            <img
              src={IMAGES.food1}
              alt="Freshly prepared Indian dishes at Kasdol Hotel restaurant"
              loading="lazy"
              className="h-64 w-full rounded-md object-cover sm:h-72"
            />
          </Reveal>
          <Reveal delay={120}>
            <img
              src={IMAGES.food2}
              alt="Warm restaurant ambience at Kasdol Hotel"
              loading="lazy"
              className="h-64 w-full rounded-md object-cover sm:h-72"
            />
          </Reveal>
        </div>

        <Reveal id="restaurant-menu" className="mt-14 scroll-mt-28">
          <div className="flex flex-wrap justify-center gap-2.5">
            {TABS.map((t) => (
              <button
                key={t.label}
                type="button"
                data-testid={t.testid}
                onClick={() => setTab(t.label)}
                aria-pressed={tab === t.label}
                className={`rounded-full border px-6 py-2.5 text-sm font-semibold transition-colors duration-300 ${
                  tab === t.label
                    ? "border-navy bg-navy text-cream"
                    : "border-navy/20 bg-white text-navy/70 hover:border-gold hover:text-gold"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          <div data-testid="restaurant-menu-list" className="mx-auto mt-10 grid max-w-4xl gap-x-12 gap-y-6 sm:grid-cols-2">
            {MENU[tab].map((item) => (
              <div key={item.name} className="flex items-start justify-between gap-4 border-b border-dashed border-navy/15 pb-4">
                <div>
                  <h3 className="font-serif text-lg font-semibold text-navy">{item.name}</h3>
                  <p className="mt-0.5 text-xs text-ink/55">{item.desc}</p>
                </div>
                <span className="shrink-0 font-serif text-lg font-semibold text-gold">{item.price}</span>
              </div>
            ))}
          </div>
          <p className="mt-6 text-center text-xs italic text-ink/45">Sample menu — prices are demo content.</p>
        </Reveal>

        <Reveal className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a href="#restaurant-menu" data-testid="restaurant-view-menu-cta" className="btn-gold w-full sm:w-auto">
            View Restaurant Menu
          </a>
          <a
            href="#reserve-table"
            data-testid="restaurant-reserve-cta"
            className="inline-flex w-full items-center justify-center gap-2 rounded-sm border border-navy/25 px-7 py-3.5 text-sm font-semibold uppercase tracking-widest text-navy transition-colors duration-300 hover:border-gold hover:text-gold sm:w-auto"
          >
            Reserve a Table
          </a>
        </Reveal>

        <Reveal delay={100}>
          <div id="reserve-table" className="mx-auto mt-14 max-w-3xl scroll-mt-28 rounded-md bg-ivory p-6 shadow-xl sm:p-10">
            <h3 className="font-serif text-2xl font-semibold text-navy sm:text-3xl">Reserve a Table</h3>
            <p className="mt-2 text-sm text-ink/60">Tell us when you are coming and we will keep a table ready.</p>
            <div className="mt-7">
              <EnquiryForm
                formTestId="restaurant-reservation-form"
                submitTestId="restaurant-form-submit"
                fields={FIELDS}
                submitLabel="Reserve Table"
                service="restaurant"
                successTitle="Table Reservation Received"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
